export default __webpack_public_path__ + "static/media/DemoUser.3b932c6c.svg";